import { render, staticRenderFns } from "./BookPhotos.vue?vue&type=template&id=c2a15938"
import script from "./BookPhotos.vue?vue&type=script&lang=js"
export * from "./BookPhotos.vue?vue&type=script&lang=js"
import style0 from "./BookPhotos.vue?vue&type=style&index=0&id=c2a15938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports